"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadMoreControl = void 0;
class ReadMoreControl {
    constructor() {
        $('body').on('click', '[js-read-more]', this.onToggle.bind(this));
    }
    onToggle(e) {
        const readMoreText = 'Read more';
        const readLessText = 'Read less';
        let switchElement = $(e.currentTarget);
        let targetId = switchElement.attr('aria-controls');
        if (switchElement.text().trim() == readMoreText) {
            switchElement.text(readLessText);
        }
        else {
            switchElement.text(readMoreText);
        }
        $(`#${targetId}`).toggleClass("readMoreCover");
    }
}
exports.ReadMoreControl = ReadMoreControl;
